import { getCategoryById, getVehicleClassById, getDate } from 'services/types';
import { ParkingCell } from 'libs/ui';
import { user, data } from 'services';
import { ChangeTypeSetForm, DelSetForm, StatusSetForm, TariffSetForm, DateSetForm, ClassSetForm, CategorySetForm } from 'libs/forms';

export const getTableParams = (t) => {
  const withBalance = window.config.use_subscription_balance;
  const setRight = user.haveRight('subscription.bulk');
  const setActions = setRight
    ? [
        {
          title: 'Удалить',
          key: 'del',
          form: DelSetForm,
          simple: true,
          method: 'subscriptions.bulk_delete',
          idsParam: 'ids',
          isDanger: true,
        },
        {
          title: 'Статус',
          key: 'status',
          form: StatusSetForm,
          dict: 'rfid.status',
          dictExclude: ['blocked_by_client'],
          simple: false,
          method: 'subscriptions.bulk_change_status',
          idsParam: 'ids',
        },
        {
          title: 'Тариф',
          key: 'tariff',
          form: TariffSetForm,
          dict: 'rfid.status',
          simple: false,
          method: 'subscriptions.bulk_update_tariff',
          idsParam: 'ids',
        },
        {
          title: 'Категория',
          key: 'tscategory',
          form: CategorySetForm,
          simple: false,
          method: 'subscriptions.bulk_change_vehicle_category',
          idsParam: 'ids',
        },
        {
          title: 'Класс ТС',
          key: 'tsclass',
          form: ClassSetForm,
          simple: false,
          method: 'subscriptions.bulk_change_vehicle_class',
          idsParam: 'ids',
        },
        {
          title: 'Действует по',
          key: 'dateto',
          form: DateSetForm,
          simple: false,
          method: 'subscriptions.bulk_change_end_at',
          idsParam: 'ids',
        },
        {
          title: 'Перенести в БСК',
          key: 'privileged',
          form: ChangeTypeSetForm,
          simple: true,
          method: 'subscriptions.bulk_change_mean_type',
          idsParam: 'ids',
        },
      ]
    : [];

  const getBalance = (__val, __params, row) => {
    const value = row.data?.balance;
    if (value === undefined) {
      return '';
    }

    return Math.round(value / 100);
  };

  const getFields = (props) => {
    const fields = [
      { name: 'pan', title: t('sections.Абонемент'), width: 180, sortField: 'pan' },
      { name: 'vehicle_plate', title: t('sections.ГРЗ'), width: 112, sortField: 'vehicle_plate' },
      {
        name: 'is_blocked',
        title: t('grid.Статус'),
        width: 155,
        sortField: 'status',
        render: (val) => data.getDictValue('payment_mean.status', val),
      },
      {
        name: 'start_at',
        title: t('form.Дата действия с'),
        width: 210,
        sortField: 'start_at',
        render: (val) => getDate(val),
      },
      {
        name: 'end_at',
        title: t('form.Дата действия по'),
        width: 210,
        sortField: 'end_at',
        render: (val) => getDate(val),
      },
      {
        name: 'balance',
        title: t('grid.Баланс, ₽'),
        width: 150,
        sortField: 'balance',
        enabled: withBalance,
        render: (val, params, row) => getBalance(val, params, row),
      },
      { name: 'name', title: t('form.Держатель'), sortField: 'name' },
    ];
    if (!props.clientId) {
      fields.push({ name: 'client_name', title: t('form.Клиент'), width: 145 });
    }

    fields.push({
      name: 'vehicle_class',
      title: t('dict_filter.Класс ТС'),
      width: 160,
      sortField: 'vehicle_class',
      render: (val) => getVehicleClassById(val),
    });
    fields.push({
      name: 'vehicle_category',
      title: t('form.Категория'),
      width: 112,
      sortField: 'vehicle_category',
      render: (val) => getCategoryById(val),
    });
    fields.push({ name: 'tariff', title: t('form.Тариф'), width: 180 });
    fields.push({ name: 'comment', title: t('filter.Комментарий'), width: 150 });

    if (window.config.central) {
      fields.unshift({
        name: 'parking_id',
        title: t('grid.Парковка'),
        render: (val) => <ParkingCell parking_id={val} cmp={'span'} />,
        width: 140,
      });
    }

    return fields;
  };

  // get row class
  const getRowClass = (row) => {
    let out = '';
    out += ' ' + row.status;
    return out;
  };

  return { getFields, getRowClass, withComment: true, setActions };
};
